// extracted by mini-css-extract-plugin
module.exports = {"root":"ScanCode_root__daMaa","form":"ScanCode_form__sAmIe"};